import MuiCheckbox, { CheckboxProps } from '@mui/material/Checkbox';
import { usePalette } from 'src/hooks';

export const Checkbox = ({ sx, ...props }: CheckboxProps) => {
  const { text } = usePalette();

  return <MuiCheckbox sx={{ color: text.primary, ...sx }} {...props} />;
};
